import styled, { keyframes } from 'styled-components';

const glow = keyframes`
  0%, 100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
`;

export const ScAnimatedCrystal = styled.div`
  position: relative;

  .crystal-1,
  .crystal-2 {
    position: absolute;
    top: 0;
    left: 0;
  }

  .crystal-2 {
    animation: ${glow} 1.8s ease-in-out infinite;
  }
`;
